import React, { FunctionComponent } from "react"

import { IApiLink } from "@/types"
import { ApiLinkEntity } from "config/constants"
import Documents from "components/Documents/Documents"

interface IAssetDocumentsProps {
    lmid?: string
    linkGetAssetDocuments?: IApiLink
    linkAddAssetDocuments?: IApiLink
    hideTitle?: boolean
}

const AssetDocuments: FunctionComponent<React.PropsWithChildren<IAssetDocumentsProps>> = ({
    lmid,
    linkGetAssetDocuments,
    linkAddAssetDocuments,
    hideTitle = false,
}) => {
    return (
        <Documents
            entity={ApiLinkEntity.assetDocument}
            linkGetDocuments={linkGetAssetDocuments}
            linkAddDocuments={linkAddAssetDocuments}
            zipFileNameSuffix={lmid}
            hideTitle={hideTitle}
        />
    )
}

export default AssetDocuments
